export default __webpack_public_path__ + "static/media/gelbox_eject_gel.fea7b953.svg";